import { Space } from 'antd';
import React, { FC } from 'react';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { fullName } from 'utils/full-name';

interface CreatedByProps {
  user: User;
}
export const CreatedBy: FC<CreatedByProps> = ({ user }) => (
  <Space>
    <Avatar
      size="small"
      name={fullName(user)}
      companyLogoUrl={user?.company?.companyLogoUrl}
      src={user?.photoUrl}
    />
    <div>{fullName(user) || user?.emailId}</div>
  </Space>
);
